module.exports = {
    "collectionLabel": `N\xe1vrhy`
};


//# sourceMappingURL=cs-CZ.main.js.map
